import React from "react";
import { Panel } from "../../components/ui/dashboard";

const DeliveryHistory: React.FC = () => {
  return (
    <div className="p-4 md:p-6">
      <Panel title="Delivery History" subtitle="Download invoices for completed consignments">
        <div className="space-y-2">
          {[
            { lr: "TT-2026-00191", date: "2026-04-08", amount: "INR 22,540" },
            { lr: "TT-2026-00192", date: "2026-04-07", amount: "INR 10,420" },
          ].map((row) => (
            <div key={row.lr} className="rounded-xl border border-slate-100 p-3 flex items-center justify-between">
              <div>
                <p className="text-sm font-semibold text-slate-900">{row.lr}</p>
                <p className="text-xs text-slate-500">{row.date} · {row.amount}</p>
              </div>
              <button className="px-2 py-1 rounded-md text-xs bg-slate-100 text-slate-700">Download Invoice</button>
            </div>
          ))}
        </div>
      </Panel>
    </div>
  );
};

export default DeliveryHistory;